<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start -->
<div class="afterLoginPageContainer" translate="no">
    <div class="container p-0">
        <div class="mainContent" *ngIf="companyDetails">
            <div class="card">
                <div class="top-content">
                    <div class="back-btn" (click)="goBack()">
                        <i class="fa-solid fa-chevron-left"></i>
                    </div>

                    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" *ngIf="companyDetails.media.brand_cover && companyDetails.media.brand_cover.length > 0; else noCoverImage">

                        <!-- DYNAMIC INDICATORS -->
                        <div class="carousel-indicators"
                             *ngIf="companyDetails.media.brand_cover.length > 1">
                      
                          <button *ngFor="let _ of companyDetails.media.brand_cover; let i = index"
                                  type="button"
                                  data-bs-target="#carouselExampleIndicators"
                                  [attr.data-bs-slide-to]="i"
                                  [class.active]="i === 0"
                                  [attr.aria-current]="i === 0 ? 'true' : null"
                                  [attr.aria-label]="'Slide ' + (i + 1)">
                          </button>
                      
                        </div>
                      
                      
                        <!-- SLIDES -->
                        <div class="carousel-inner" [class.multiple-items]="companyDetails.media.brand_cover.length > 1">
                          <div class="carousel-item"
                               *ngFor="let item of companyDetails?.media?.brand_cover; let i = index"
                               [class.active]="i === 0">
                      
                            <img 
                              [src]="item.bigthumb_url || '/assets/images/default_company_image.png'"
                              (error)="handleImageError($event)"
                              (click)="openMedia(item.media_url)"
                              (keydown.enter)="openMedia(item.media_url)"
                              role="button"
                              tabindex="0"
                              class="d-block w-100"
                              [alt]="item.title || 'Default Image'"
                            />
                      
                            <span *ngIf="item.media_type === 'youtubevideo'" class="playicon" (click)="openMedia(item.media_url)" (keydown.enter)="openMedia(item.media_url)"
                            [attr.aria-label]="'View full size company video'">
                              <i class="fa-brands fa-youtube"></i>
                            </span>
                      
                          </div>
                         

                        </div>
                      
                      
                        <!-- CONTROLS -->
                        <button class="carousel-control-prev"
                                *ngIf="companyDetails.media.brand_cover.length > 1"
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                      
                        <button class="carousel-control-next"
                                *ngIf="companyDetails.media.brand_cover.length > 1"
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      
                    </div>
                   <ng-template #noCoverImage>
                    <div class="img-outer">
                        <img  src="/assets/images/default_company_image.png" alt="Default Cover Image" class="d-block w-100 default-img"/>
                    </div>
                   </ng-template>
                  
                      

                    <div class="content-wrapper" [ngStyle]="{background:  companyDetails.image_max_color }">
                        <div class="company-details">
                            <img [src]="companyDetails.image_bigthumb_url" alt="John Deere Logo" class="company-logo">
                            <div class="text-content">
                                <h5 class="company-name">{{ companyDetails.organisation_name }}</h5>
                                <p class="pavilion-name">{{ pavilionName }}</p>
                            </div>
                        </div>
                        <div class="menu-tabs">
                            <button class="tab" [class.active]="activeTab === 'about'"
                                (click)="setActiveTab('about')">About</button>
                            <button class="tab" [class.active]="activeTab === 'products'"
                                (click)="setActiveTab('products')">Products</button>
                            <button class="tab" [class.active]="activeTab === 'videos'"
                                (click)="setActiveTab('videos')">Videos</button>
                        </div>
                    </div>
                </div>
                <!-- Card Content -->
                <div class="card-body tab-content">
                    <div class="about" [class.active]="activeTab === 'about'">
                        <div class="company-description">
                            <div class="product-description">
                                <div class="inner-content">
                                    <span [innerHTML]="isExpanded ? fullContent : truncatedContent"></span>
                                    <ng-container *ngIf="isLongText">
                                        <a href="#" (click)="toggleReadMore($event)"
                                            [ngStyle]="{ color : companyDetails.image_max_color }">
                                            {{ isExpanded ? ' Read less' : ' Read more' }}
                                        </a>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="image-gallery" *ngIf="areImagesAvailable">
                               
                                <div class="media mb-5">
                                    <h6 class="mb-3" [ngStyle]="{ color : companyDetails.image_max_color }">
                                        Images
                                    </h6>
                                    <div class="innerMedia">
                                        <ng-container
                                            *ngFor="let item of companyDetails?.media?.brand_media; let i = index">
                                            <div class="box" *ngIf="item.media_type === 'image'">
                                                <img [src]="item.bigthumb_url" [alt]="item.title"  (error)="handleImageError($event)" />
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="brochure-list mb-5" *ngIf="companyDetails.media.brand_brochures.length > 0">
                                    <h6 class="heading" [ngStyle]="{ color : companyDetails.image_max_color }">For More Details, Download Brochure</h6>
                                    <ng-container
                                        *ngFor="let brochure of companyDetails?.media?.brand_brochures; let i = index">
                                        <a [href]="brochure.media_url" class="view-all-link" target="_blank"
                                            [download]="brochure.title">
                                            <div class="brochure">
                                                <div class="imgOuter">
                                                    <img [src]="brochure.bigthumb_url" alt="">
                                                </div>
                                                <h5 class="title">{{brochure.title}}</h5>
                                                <div class="pdf-icon">
                                                    <span class="material-icons"> picture_as_pdf </span>
                                                    <i class="fa fa-download"></i>
                                                </div>
                                            </div>
                                        </a>
                                    </ng-container>
                                </div>
                                <div class="product-recommendations">
                                    <div class="inner-elements"
                                        *ngIf="!isLoadingMore && productList && productList.length > 0">
                                        <h6 class="heading mb-0" [style.color]="companyDetails.image_max_color || '#009F4B'">
                                            More
                                            From, {{companyDetails.brandname}}</h6>
                                        <div class="media-slider">
                                            <div class="product-list inner-media">
                                                <div class="block" *ngFor="let product of productList">
                                                    <a (click)="goToProductDetails(product.encoded_product_id)">
                                                        <div class="card">
                                                            <div class="wrapper position-relative">
                                                                <img class="card-img-top"
                                                                    [src]="product.media_type === 'image' ? product.media_url : product.image_bigthumb_url"
                                                                    (error)="handleImageError($event)"
                                                                    alt="{{ product.title_english }}"  >
                                                                <span *ngIf="product.media_type === 'youtubevideo'"
                                                                    class="playicon">
                                                                    <i class="fa-brands fa-youtube"></i>
                                                                </span>
                                                            </div>
                                                            <div class="card-body">
                                                                <h6 class="product-name">{{product.title_english}}</h6>
                                                                <p class="company-name">{{product.brandname}}</p>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section-loader text-center" *ngIf="isLoadingMore">
                                        <div class="spinner-border text-success" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="products" [class.active]="activeTab === 'products' ">
                        <div class="product-list" *ngIf="productList.length > 0; else noProducts">
                            <div class="block" *ngFor="let product of productList; let i = index">
                                <a (click)="goToProductDetails(product.encoded_product_id)">
                                    <div class="card">
                                        <div class="wrapper position-relative">
                                            <img class="card-img-top" [src]="product.smallthumb_url"
                                            (error)="handleImageError($event)"
                                                [alt]="product.title_english">
                                            <span *ngIf="product.media_type === 'youtubevideo'" class="playicon">
                                                <i class="fa-brands fa-youtube"></i>
                                            </span>
                                        </div>
                                        <div class="card-body">
                                            <p class="card-text">{{ product.title_english }}</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <ng-template #noProducts>
                            <div class="text-center no-data">
                                <img src="/assets/images/no-product.png" alt="No Products" class="mb-3" />
                                <h3>No products associated to show</h3>
                            </div>
                        </ng-template>
                    </div>
                    <div class="videos" [class.active]="activeTab === 'videos'">
                        <div class="video-list" *ngIf="youtubeVideos.length > 0; else noVideos">
                            <div class="mb-3 position-relative" *ngFor="let video of youtubeVideos">
                                <a class="text-center" [href]="video.media_url" target="_blank">
                                    <img [src]="video.bigthumb_url" alt="Video Thumbnail" class="w-100" />
                                    <div class="play">
                                        <i class="fa-solid fa-play"></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <ng-template #noVideos>
                            <div class="text-center no-data">
                                <img src="/assets/images/video-editing.png" alt="No Videos" class="mb-3" />
                                <h3>No videos associated to show</h3>
                            </div>
                        </ng-template>
                    </div>
                    <div class="catlogWrapper mt-5 d-block" (click)="goToTicketPage()" *ngIf="this.eventDetails?.allow_to_register === 1">
                        <img src="/assets/images/buy_your_ticket.png" alt="Go To Digital Catalogue" />
                    </div>
                </div>
                <div class="action-btns">
                    <div class="msg-div" *ngIf="successMsg"
                    [ngStyle]="{ background: successGradientBackground }">
                        <span [style.color]="companyDetails.image_max_color || '#009F4B'"><i class="fa-solid fa-circle-check me-3"></i>{{ successText }}</span>
                        <a class="view-link" [style.color]="companyDetails.image_max_color || '#009F4B'" routerLink="/catalogue/company-wishlist">View Shortlist</a>
                    </div>
                    <div class="wrapper">
                        <span class="outer-box" (click)="shortlistCompany()">
                            <i class="fa-regular fa-circle-check" *ngIf="!liked"></i>
                            <i class="fa-solid fa-circle-check" *ngIf="liked" [style.color]="companyDetails.image_max_color || '#009F4B'" [class.like-animate]="liked"></i>
                        </span>
                        <button (click)="openModel()" class="contact-btn" [ngStyle]="{ background : companyDetails.image_max_color }">
                            <i class="fa-solid fa-phone"></i>Contact Me</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>
<app-interest-share-popup 
#interestSharedPopup 
(confirmClicked)="onConfirmPopup()" 
(doNotShowAgainChange)="onDoNotShowChange($event)"
(cancelClicked)="onCancelPopup()"></app-interest-share-popup>
<app-interest-shared-success-popup #successModal></app-interest-shared-success-popup>